import React, { useEffect, useState } from 'react';
import { Form, Input, Collapse, Select, Upload } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import Education from './Components/Education';
import Skills from './Components/Skills';
import Certifications from './Components/Certifications';
import Employment from './Components/Employment';

import { postRequest } from '../../../../services/requestService';
import { ALL_JOBS_OPTIONS } from './constants';
// import { ResumePrint } from '../ResumePrint';
import "./index.scss";
import Button from '../../../../components/forms/Button';
import { BUTTON_VARIANT_SECONDARY } from '../../../../components/forms/Button/constants';
import { getUserData, updateResume } from '../../../../store/reducers/Auth/actions';
import FileUpload from '../../../../components/forms/FileUpload';
import { getLastResume } from '../../../../services/resumeService';

const { Panel } = Collapse;

const MissingInfoStep = (props) => {
    const { userDetails } = useSelector(({ AuthReducer }) => AuthReducer);
    const [form] = Form.useForm();
    const dispatch = useDispatch();
    const [changedParams, setChangedParams] = useState([])
    const [resume, setResume] = useState({})
    const hasChangedParams = ['firstName', 'lastName', 'email', 'phoneNumber', 'currentLocation']
    .every(field => form.getFieldValue(field)?.trim?.().length > 0);
    const [loading, setLoading] = useState(false)
    const refreshChangedParams = (oldResume, newResume) => {
        const params = ["firstName", "lastName", "email", "phoneNumber", "currentLocation"]
        let changedParams = [];
        params.forEach(param => {
            if (JSON.stringify(oldResume[param]) !== JSON.stringify(newResume[param])) {
                changedParams.push(param)
            }
        })
        setChangedParams(changedParams);
    }

    useEffect(() => {
        if (userDetails.resumeFiles?.length) {
            const lastResume = getLastResume(userDetails)
            setResume({ ...lastResume })
        }
    }, [userDetails])

    useEffect(() => {

        if (resume) {
            form.setFieldsValue({
                ...resume,
                email: resume.email || userDetails.email || "",
                jobSearchQueries: resume.jobSearchQueries || [], // Initialize as an empty array
            });
            setChangedParams([])
        }

    }, [resume]);

    const handleFormSubmit = async (values) => {
        const updatedFormValues = form.getFieldsValue()
        const formData = {
            resumeId: resume._id,
            ...updatedFormValues
        };
        setLoading(true)
        const res = await postRequest('resume/update', formData);
        dispatch(updateResume(res.data.resume))
        setTimeout(() => {
            setLoading(false)
            dispatch(getUserData())
            props.onContinue && props.onContinue();
        }, 2000)

        // dispatch(push('/'));
    };

    // Handles adding selected job titles to the array
    const onSelectJob = (value) => {
        const currentValues = form.getFieldValue('jobSearchQueries') || [];
        if (!currentValues.includes(value)) {
            form.setFieldsValue({
                jobSearchQueries: [...currentValues, value]
            });
        }
        refreshChangedParams(resume, form.getFieldsValue())
    };
    const onRevert = () => {
        form.setFieldsValue({
            ...resume,
            email: resume.email || userDetails.email || "",
            jobSearchQueries: resume.jobSearchQueries || [], // Initialize as an empty array
        });
        setChangedParams([])
    }
    const onChange = (key, value) => {
        const updatedParams = form.getFieldsValue();
        updatedParams[key] = value;
        form.setFieldValue(key, value)
        refreshChangedParams(resume, updatedParams)
    }

    return (
        <Form
            form={form}
            className="missing-info-step"
            layout="vertical"
            onFinish={handleFormSubmit}
            initialValues={{
                firstName: "",
                lastName: "",
                email: "",
                phoneNumber: "",
                currentLocation: '',
            }}
            onChange={e => {
                refreshChangedParams(resume, form.getFieldsValue())
            }}
            onFinishFailed={(errorInfo) => {
                form.scrollToField(errorInfo.errorFields[0].name); // Scroll to first invalid field
            }}
        >
            <div className="row">
                <Form.Item name="firstName" label="First name" rules={[{ required: true, message: "Please fill your first name!" }]}>
                    <Input placeholder="John" />
                </Form.Item>
                <Form.Item name="lastName" label="Last name" rules={[{ required: true, message: "Please fill your last name!" }]}>
                    <Input placeholder="Doe" />
                </Form.Item>
            </div>
            <div className="row">
                <Form.Item name="email" label="Email" rules={[{ required: true, message: "Please fill your email!" }]}>
                    <Input placeholder="Enter your email" />
                </Form.Item>
                <Form.Item name="phoneNumber" label="Phone number" rules={[{ required: true, message: "Please fill your phone number!" }]}>
                    <Input placeholder="Enter your phone number" />
                </Form.Item>
            </div>
            <Form.Item name="currentLocation" label="Current Location">
                <Input placeholder="Enter your current location" />
            </Form.Item>
            <div className="actions" >
                <div className="left">
                    {changedParams?.length ? `You've changed ${changedParams.length} propert${changedParams.length === 1 ? 'y' : 'ies'}` : null}
                </div>
                <div className="right">
                    <Button disabled={!hasChangedParams} variant={BUTTON_VARIANT_SECONDARY} onClick={onRevert}>Revert</Button>
                    <Button onClick={handleFormSubmit} disabled={!hasChangedParams} loading={loading}>Continue</Button>
                </div>
            </div>
        </Form>
    );
};

export default MissingInfoStep;